import React from 'react'

function BarIndex({maxEuroValue, switchEuro, maxKwhValue}) {
    return (
        <div className="month_graph-index">
            <div className="month_graph-bar">
                <p>{parseFloat(switchEuro ? maxEuroValue : maxKwhValue).toFixed(2).replace(/\./g, ",")} {switchEuro ? '€' : <span>kwh</span>}</p>
                <p>{parseFloat(switchEuro ? maxEuroValue / 2 : maxKwhValue / 2).toFixed(2).replace(/\./g, ",")} {switchEuro ? '€' : <span>kwh</span>}</p>
                <p>0</p>

            </div>
            <div className="month_graph-avarage" style={{ background: 'translarent' }}></div>
            <div className="month_graph-day">
                <p></p>
            </div>
        </div>
    )
}

export default BarIndex